import AdminNewSidebar from "components/admin/AdminNewSidebar";
import React, { useEffect, useState } from "react";
import { Box, Container } from "@mui/material";
import { Header } from "components";
import { useTranslation } from "react-i18next";
import { Button, Form, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import apis from "../../services";
import { useNavigate, useParams } from "react-router-dom";
import { FaPlus } from "react-icons/fa";


export default function EditPopup() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id, lang } = useParams();

  const [loader, setLoader] = useState(false);
  const [popupTypes, setPopupTypes] = useState([]);
  const [selectedType, setSelectedType] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);
  const [links, setLinks] = useState([""]);

  const [formData, setFormData] = useState({
    id: "",
    titleEn: "",
    titleSp: "",
    subtitleEn:"",
    subtitleSp:"",
    contentEn: "",
    contentSp: "",
    buttonNameEn: "",
    buttonNameSp: "",
    type: "",
  });

  const fetchPopupTypes = async () => {
    try {
      const response = await apis.getPopupTypes();
      if (response?.data?.status) {
        setPopupTypes(response.data.data);
      }
    } catch (error) {
      toast.error("Failed to fetch popup types");
    }
  };

  const fetchPopupDetails = async () => {
    try {
      setLoader(true);
      const response = await apis.getPopupbyId(id);
      if (response?.data?.status) {
        const popup = response.data.popup;
        setFormData({
          id: popup._id,
          titleEn: popup.title_en || "",
          titleSp: popup.title_sp || "",
          subtitleEn: popup.sub_title_en || "",
          subtitleSp: popup.sub_title_sp || "",
          contentEn: popup.body_en || "",
          contentSp: popup.body_sp || "",
          buttonNameEn: popup.button_en || "",
          buttonNameSp: popup.button_sp || "",
          type: popup.type || "",
          link:popup.link || ""
        });
        setSelectedType(popup.type);
        if (popup.media && popup.media.length > 0) {
          setImagePreview(popup.media[0]);
        }
        setLinks(Array.isArray(popup.link) ? popup.link : [popup.link || ""]);
        if (popup.media && popup.media.length > 0) {
          setImagePreview(popup.media[0]);
        }
        setInitialDataLoaded(true);
      }
    } catch (error) {
      toast.error("Failed to fetch popup details");
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchPopupTypes();
    if (id) {
      fetchPopupDetails();
    }
  }, [id]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedImage(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const onChangeHandler = (e) => {
    const { id, value } = e.currentTarget;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };
  const handleLinkChange = (index, value) => {
    const updatedLinks = [...links];
    updatedLinks[index] = value;
    setLinks(updatedLinks);
  };

  const handleAddLink = () => {
    if (links.length < 3) {
      setLinks([...links, ""]);
    } else {
      toast.error("You can only add up to 3 links.");
    }
  };
  const updatePopup = async (popupData) => {
    try {
      setLoader(true);
      const payload = new FormData();
      payload.append("id", popupData.id);
      payload.append("title_en", popupData.titleEn);
      payload.append("title_sp", popupData.titleSp);
      payload.append("sub_title_en", popupData.subtitleEn);
      payload.append("sub_title_sp", popupData.subtitleSp);
      payload.append("body_en", popupData.contentEn);
      payload.append("body_sp", popupData.contentSp);
      payload.append("button_en", popupData.buttonNameEn);
      payload.append("button_sp", popupData.buttonNameSp);
      payload.append("type", selectedType);
      const validLinks = links.filter(link => link.trim());  // Filter out empty or invalid links
    if (validLinks.length > 0) {
      validLinks.forEach((link) => {
        payload.append("link[]", link.trim());
      });
    }
      if (selectedImage) {
        payload.append("media", selectedImage);
      }

      const response = await apis.UpdatePopup(payload);
      if (response?.data?.status) {
        toast.success("Popup updated successfully");
        navigate(`/${lang || "sp"}/admin/popup-management`);
      } else {
        toast.error(response?.data?.message || "Failed to update popup");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Error updating popup");
    } finally {
      setLoader(false);
    }
  };

  const submitHandler = (e) => {
    e.preventDefault();
    const { titleEn, titleSp,subtitleEn,subtitleSp ,contentEn, contentSp, buttonNameEn, buttonNameSp } = formData;

    if (!contentEn || !contentSp || !buttonNameEn || !buttonNameSp || !selectedType) {
      return toast.error("All fields are required in both English and Spanish.");
    }

    updatePopup(formData);
  };

  return (
    <Box className="dashboard-main">
      <AdminNewSidebar />
      <div className="dashboard-section-main">
        <Box component="main" sx={{ flexGrow: 1, height: "100vh", overflow: "auto" }} className="custom-scroll">
          <Header />
          {loader && !initialDataLoaded ? (
            <div className="loader-container">
              <div className="loader" />
            </div>
          ) : (
            <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }} className="mainContainerComp">
              <div style={{ display: "flex", justifyContent: "center", padding: "20px" }}>
                <h2 style={{
                  color: "#000",
                  fontFamily: "'Poppins', sans-serif",
                  fontSize: "36px",
                  letterSpacing: "2px",
                  textAlign: "center",
                  margin: 0,
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  textShadow: "2px 2px 4px rgba(0, 0, 0, 0.3)",
                }}>
                  {t("buttons.edit-popup")}
                </h2>
              </div>

              <div className="p-4 mb-5" style={{ border: "1px solid #e0201c", borderRadius: "30px" }}>
                <h4 className="mb-4">{t("buttons.edit-popup-details")}</h4>
                <Form onSubmit={submitHandler}>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Title (English)</Form.Label>
                        <Form.Control
                          type="text"
                          id="titleEn"
                          value={formData.titleEn}
                          onChange={onChangeHandler}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Title (Spanish)</Form.Label>
                        <Form.Control
                          type="text"
                          id="titleSp"
                          value={formData.titleSp}
                          onChange={onChangeHandler}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Subtitle (Spanish)</Form.Label>
                        <Form.Control
                          type="text"
                          id="subtitleEn"
                          value={formData.subtitleEn}
                          onChange={onChangeHandler}
                          
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Subtitle (Spanish)</Form.Label>
                        <Form.Control
                          type="text"
                          id="subtitleSp"
                          value={formData.subtitleSp}
                          onChange={onChangeHandler}
                          
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Content (English)</Form.Label>
                        <Form.Control
                          as="textarea"
                          id="contentEn"
                          rows={5}
                          value={formData.contentEn}
                          onChange={onChangeHandler}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Content (Spanish)</Form.Label>
                        <Form.Control
                          as="textarea"
                          id="contentSp"
                          rows={5}
                          value={formData.contentSp}
                          onChange={onChangeHandler}
                          required
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Button Name (English)</Form.Label>
                        <Form.Control
                          type="text"
                          id="buttonNameEn"
                          value={formData.buttonNameEn}
                          onChange={onChangeHandler}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Button Name (Spanish)</Form.Label>
                        <Form.Control
                          type="text"
                          id="buttonNameSp"
                          value={formData.buttonNameSp}
                          onChange={onChangeHandler}
                          required
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>{t("fields.type")}</Form.Label>
                        <Form.Select
                          value={selectedType}
                          onChange={(e) => setSelectedType(e.target.value)}
                          required
                        >
                          <option value="">Select Popup Type</option>
                          {popupTypes.map((type) => (
                            <option key={type.value} value={type.value}>
                              {type.label}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    <Col md={6}>
  <Form.Group className="mb-3">
    <Form.Label>{t("fields.link")}</Form.Label>

    {links.map((link, index) => (
      <Form.Control
        key={index}
        type="text"
        placeholder={`Enter link ${index + 1}`}
        value={link}
        onChange={(e) => handleLinkChange(index, e.target.value)}
        className="mb-2"
        pattern="^(https?:\/\/|www\.)[^\s]+$"
      />
    ))}

    {/* Button appears only if there are less than 3 links */}
    {links.length < 3 && (
      <div className="mt-2">
        <Button
          type="button"
          onClick={handleAddLink}
          size="sm"
          className="d-block" // Make button behave like a block (full line)
          style={{
            marginTop: "10px",
            border: "1px solid rgb(224, 32, 28)",
            borderRadius: "30px",
            color: "rgb(224, 32, 28)", 
            backgroundColor: "transparent",
            width: "200px", // Custom width
          }}
        >
          <FaPlus /> Add Link
        </Button>
      </div>
    )}

    {/* Error Text */}
    <Form.Text className="text-danger d-block mt-2">
      Please enter a valid link starting with http://, https://, or www.
    </Form.Text>
  </Form.Group>
</Col>





                    <Col md={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>{t("fields.image-select")}</Form.Label>
                        <div
                          style={{
                            border: "2px dashed #e0201c",
                            borderRadius: "10px",
                            padding: "20px",
                            textAlign: "center",
                          }}
                        >
                          <Form.Control
                            type="file"
                            accept="image/*"
                            onChange={handleImageChange}
                            style={{ display: "none" }}
                            id="image-upload"
                          />
                          <label htmlFor="image-upload" style={{ cursor: "pointer", color: "#e0201c" }}>
                            {imagePreview ? "Change Image" : "Click to Upload Image"}
                          </label>
                        </div>
                        {imagePreview && (
                          <div className="text-center mt-2">
                            <img src={imagePreview} alt="Preview" style={{ width: "200px", borderRadius: "10px" }} />
                            <div className="mt-2">
                              <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() => {
                                  setImagePreview(null);
                                  setSelectedImage(null);
                                }}
                              >
                                Remove Image
                              </Button>
                            </div>
                          </div>
                        )}
                      </Form.Group>
                    </Col>

                    <Col md={12} className="text-center">
                      <Button
                        variant="outline-danger"
                        type="submit"
                        disabled={loader}
                        style={{ width: "200px", marginTop: "20px" }}
                      >
                        {loader ? t("buttons.updating") : t("buttons.update")}
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Container>
          )}
        </Box>
      </div>
    </Box>
  );
}
